<template>
  <div>
    <StaticDataTable class="static-table-list">
      <template v-slot:header>
        <tr>
          <th width="40%">Setting</th>
          <th width="60%">Value</th>
        </tr>
      </template>
      <template v-slot:body>
        <template v-if="stockTypeIsGlass">
          <tr>
            <td class="font-weight-bold">Offcut Height</td>
            <td v-if="isValueSet(stockData.glassMinOffcutHeight) && !editing">{{stockData.glassMinOffcutHeight}}mm</td>
            <td v-if="!isValueSet(stockData.glassMinOffcutHeight) && !editing" class="font-italic text-muted">Default</td>
            <td v-if="editing">
              <FormInputText type="number" v-model="stockData.glassMinOffcutHeight" @input="stockUpdated" addon="mm" placeholder="Default" />
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Offcut Width</td>
            <td v-if="isValueSet(stockData.glassMinOffcutWidth) && !editing">{{stockData.glassMinOffcutWidth}}mm</td>
            <td v-if="!isValueSet(stockData.glassMinOffcutWidth) && !editing" class="font-italic text-muted">Default</td>
            <td v-if="editing">
              <FormInputText type="number" v-model="stockData.glassMinOffcutWidth" @input="stockUpdated" addon="mm" placeholder="Default" />
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Panel Trim</td>
            <td v-if="isValueSet(stockData.panelTrim) && !editing">{{stockData.panelTrim}}mm</td>
            <td v-if="!isValueSet(stockData.panelTrim) && !editing" class="font-italic text-muted">Default</td>
            <td v-if="editing">
              <FormInputText type="number" v-model="stockData.panelTrim" @input="stockUpdated" addon="mm" placeholder="Default" />
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Offcut Trim</td>
            <td v-if="isValueSet(stockData.offcutEdgeTrim) && !editing">{{stockData.offcutEdgeTrim}}mm</td>
            <td v-if="!isValueSet(stockData.offcutEdgeTrim) && !editing" class="font-italic text-muted">Default</td>
            <td v-if="editing">
              <FormInputText type="number" v-model="stockData.offcutEdgeTrim" @input="stockUpdated" addon="mm" placeholder="Default" />
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Panel Edge on Sheet Edge</td>
            <td v-if="isValueSet(stockData.panelEdgeOnSheetEdgeEnabled) && !editing"><IconBoolean :value="stockData.panelEdgeOnSheetEdgeEnabled" /></td>
            <td v-if="!isValueSet(stockData.panelEdgeOnSheetEdgeEnabled) && !editing" class="font-italic text-muted">Default</td>
            <td v-if="editing">
              <FormSelect :value="convertBooleanSettingToDropdown(stockData.panelEdgeOnSheetEdgeEnabled)" @input="stockData.panelEdgeOnSheetEdgeEnabled = parseBooleanSelectSetting($event); stockUpdated()" :options="panelEdgeOptions" />
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Panel Edge on Offcut Edge</td>
            <td v-if="isValueSet(stockData.panelEdgeOnOffcutEdgeEnabled) && !editing"><IconBoolean :value="stockData.panelEdgeOnOffcutEdgeEnabled" /></td>
            <td v-if="!isValueSet(stockData.panelEdgeOnOffcutEdgeEnabled) && !editing" class="font-italic text-muted">Default</td>
            <td v-if="editing">
              <FormSelect :value="convertBooleanSettingToDropdown(stockData.panelEdgeOnOffcutEdgeEnabled)" @input="stockData.panelEdgeOnOffcutEdgeEnabled = parseBooleanSelectSetting($event); stockUpdated()" :options="panelEdgeOptions" />
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Sheet Trim Top</td>
            <td v-if="isValueSet(stockData.glassTrimTop) && !editing">{{stockData.glassTrimTop}}mm</td>
            <td v-if="!isValueSet(stockData.glassTrimTop) && !editing" class="font-italic text-muted">Default</td>
            <td v-if="editing">
              <FormInputText type="number" v-model="stockData.glassTrimTop" @input="stockUpdated" addon="mm" placeholder="Default" />
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Sheet Trim Right</td>
            <td v-if="isValueSet(stockData.glassTrimRight) && !editing">{{stockData.glassTrimRight}}mm</td>
            <td v-if="!isValueSet(stockData.glassTrimRight) && !editing" class="font-italic text-muted">Default</td>
            <td v-if="editing">
              <FormInputText type="number" v-model="stockData.glassTrimRight" @input="stockUpdated" addon="mm" placeholder="Default" />
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Sheet Trim Bottom</td>
            <td v-if="isValueSet(stockData.glassTrimBottom) && !editing">{{stockData.glassTrimBottom}}mm</td>
            <td v-if="!isValueSet(stockData.glassTrimBottom) && !editing" class="font-italic text-muted">Default</td>
            <td v-if="editing">
              <FormInputText type="number" v-model="stockData.glassTrimBottom" @input="stockUpdated" addon="mm" placeholder="Default" />
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Sheet Trim Left</td>
            <td v-if="isValueSet(stockData.glassTrimLeft) && !editing">{{stockData.glassTrimLeft}}mm</td>
            <td v-if="!isValueSet(stockData.glassTrimLeft) && !editing" class="font-italic text-muted">Default</td>
            <td v-if="editing">
              <FormInputText type="number" v-model="stockData.glassTrimLeft" @input="stockUpdated" addon="mm" placeholder="Default" />
            </td>
          </tr>
        </template>
      </template>
      <template v-slot:empty v-if="!stockTypeIsGlass">
        No settings available
      </template>
    </StaticDataTable>
  </div>
</template>


<script>
import _ from 'lodash'
import formMixin from '@/mixins/form'

import { InventoryStockTypes } from '@/store/types'

export default {
  name: 'StockProductionSettingsEditor',
  model: {
    event: 'update'
  },
  mixins: [formMixin],
  props: {
    editing: Boolean,
    value: Object
  },
  data() {
    return {
      stockData: {},
      panelEdgeOptions: [
        { name: 'Default', value: 'null' },
        { name: 'Enabled', value: 'true' },
        { name: 'Disabled', value: 'false' },
      ]
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function() {
        this.stockData = _.cloneDeep(this.value)
      }
    }
  },
  computed: {
    stockTypeIsGlass() {
      return this.value.type == InventoryStockTypes.glass
    },
  },
  methods: {
    isValueSet(value) {
      if(value === null || isNaN(value))
        return false
      return true
    },
    stockUpdated() {
      this.$emit('update', this.stockData)
    },
    parseBooleanSelectSetting(value) {
      if(value === null || value == 'null')
        return null
      if(value == 'true' || value === true)
        return true
      if(value == 'false' || value === false)
        return false
      return false
    },
    convertBooleanSettingToDropdown(value) {
      if(value === null)
        return 'null'
      return value ? 'true' : 'false'
    }
  }
}
</script>